import React, {
  useContext,
  useEffect,
  useRef,
  createRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import NewProjectContext from "../../../contexts/NewProjectContext";
import Button from "../../common/Button/index.jsx";
import { ReactComponent as ArrowRightSvg } from "../../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowLeftSvg } from "../../../assets/icons/arrow-left.svg";
import { ReactComponent as UploadAccountSvg } from "../../../assets/workExchange/upload-account.svg";
import AppContext from "../../../AppContext.jsx";
import { langComponent, PAGE_STATE } from "../../../constants/index.jsx";
import _ from "lodash";
import ImageCropperEx from "../../common/ImageCropperEx";

const prefix = "new-project-work-exchange-cover";

const ProjectCover = (props) => {
  const { details, setDetails, goForward, goBackward } =
    useContext(NewProjectContext);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.project);
  const TranslationCommon = getLang(langComponent.common);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [cover, setCover] = useState(details?.cover || null);
  const [originalFileCover, setOriginalFileCover] = useState(null);
  const [crop, setCrop] = useState(null);
  const [mapGallery, setMapGallery] = useState([]);
  const [newCover, setNewCover] = useState(false);
  const imageCropRef = createRef();
  const handleImageCover = ({ blob, completedCrop, originalFile }) => {
    setCover(blob);
    setOriginalFileCover(originalFile);
    setCrop(completedCrop);
    setDetails((curr) => ({
      ...curr,
      cover: blob,
      coverOriginal: originalFile,
      coverCrop: completedCrop,
    }));
  };

  useEffect(() => {
    setPageState(PAGE_STATE.IDLE);
    // console.log(details?.cover);
    // console.log(cover);
    let imageList = [];
    if (
      details?.mainOriginalFile &&
      details?.mainOriginalFile instanceof File
    ) {
      imageList.push(details?.mainOriginalFile);
    }
    if (
      details?.secondOriginalFile &&
      details?.secondOriginalFile instanceof File
    ) {
      imageList.push(details?.secondOriginalFile);
    }
    if (details?.galleryList.length > 0) {
      const concat = imageList.concat(details?.galleryList);
      imageList = concat;
    }

    const mapList = imageList.map((item) => {
      if (item instanceof File) {
        return item;
      } else {
        return item.path;
      }
    });
    setMapGallery(mapList);

    return () => {};
  }, []);
  if (pageState !== PAGE_STATE.IDLE) {
    return <h1>Loading...</h1>;
  }
  const handleSubmitInfo = (values) => {
    setDetails((curr) => ({
      ...curr,
      cover,
      coverOriginal: originalFileCover,
      coverCrop: crop,
    }));
    goForward();
  };
  const handleDeleteCrop = () => {
    setCover(null);
    setDetails((curr) => ({ ...curr, cover: null }));
  };
  return (
    <Formik initialValues={details} onSubmit={handleSubmitInfo}>
      <Form className={prefix}>
        <div className={`${prefix}-header`}>{Translation("Project Cover")}</div>
        <div className={`${prefix}-content`}>
          <ImageCropperEx
            name={"cover"}
            aspectRatio={1.5}
            multiple={false}
            onChange={(images) => {
              if (!images || images.length === 0) {
                handleDeleteCrop();
                return;
              }

              handleImageCover(images[0]);
            }}
            defaultImages={cover}
          />
        </div>

        <div className="new-project-cta" style={{ gridColumn: "1 / 3" }}>
          <Button
            label={TranslationCommon("Return")}
            variant={"secondary"}
            leadingIcon={<ArrowLeftSvg />}
            onClick={() => goBackward()}
          />
          <Button
            label={TranslationCommon("Next")}
            type="submit"
            trailingIcon={<ArrowRightSvg />}
          />
        </div>
      </Form>
    </Formik>
  );
};

ProjectCover.propTypes = {
  _id: PropTypes.string,
};
ProjectCover.defaultProps = {
  _id: undefined,
};

export default ProjectCover;
